<template>
	<div
		class="p-checkbox"
		:class="classes"
		@click.stop.prevent="onClick"
	>
		<div class="p-checkbox__wrapper">
			<div class="p-checkbox__input">
				<input
          :checked="modelValue"
					type="checkbox"
					:disabled="disabled"
				>
				<div class="p-checkbox__elem">
					<CheckIcon class="p-icon p-icon-checkbox" />
				</div>
			</div>
			<div class="p-checkbox__label">
				{{ label }}
			</div>
			<div
				v-if="!valid"
				class="p-input__info"
			>
				{{ validInfo }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CheckIcon from '@/common/icons/CheckIcon.vue';

interface Props {
  modelValue: boolean,
	valid?: boolean;
	validInfo?: string;
	label?: string;
	disabled?: boolean;
}

// Props
const props = withDefaults(defineProps<Props>(), {valid: true});

// Computed
const classes = computed(() => ({
	'p-checkbox_default': true,
	'p-checkbox_disabled': props.disabled,
	'p-checkbox_error': !props.valid,
	'p-checkbox_checked': props.modelValue,
}));

// Emits
const emit = defineEmits(['update:modelValue']);

// Methods
const onClick = () => {
	if (props.disabled) return;
	emit('update:modelValue', !props.modelValue);
};
</script>

<style>
@import "styles/pCheckbox.scss";
</style>